var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","color":"white"}},[_c('v-col',{staticClass:"text-center grey--text",attrs:{"cols":"12"}},[_c('strong',[_vm._v(_vm._s(_vm.name))]),_vm._v(" — "+_vm._s(_vm.version)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }